// Site Footer

import './index.scss';

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default class SiteFooter {
    constructor(root) {
        this.root = root;

        this.root.querySelectorAll('.tippy').forEach((el) => {
            let button = el.querySelector('.tippy-button');
            let html = el.querySelector('.tippy-html');
            html.style.display = 'flex';

            tippy(button, {
                content: html,
                interactive: true,
                trigger: 'click'
            });
        });
    }
}
